import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Consultant from "../../../models/Consultant";
import Customer from "../../../models/Customer";
import { useConsultant, useConsultants } from "../../../networking/consultant.hooks";
import AutoCompleteInput, { AutoCompleteInputProps } from "./AutoCompleteInput";

interface Props
	extends Pick<AutoCompleteInputProps<string, Customer>, "width" | "icon" | "placeholder"> {
	onChange: (customerId?: string) => any;
	value: string;
	pool?: string;
	hidePrefix?: boolean;
}

const ConsultantAutoComplete: React.FC<Props> = ({
	pool,
	value,
	onChange,
	hidePrefix,
	...rest
}) => {
	const [search, setSearch] = useState<string>();
	const { t } = useTranslation();

	const { consultantList } = useConsultants(
		{
			page: 1,
			pageSize: 20,
			sort: "name",
			pool,
			keyword: search,
		},
		!!search
	);

	const { consultant } = useConsultant({ consultantId: value }, !!value);

	function getDisplayValue(consultant?: Consultant) {
		return consultant
			? `${consultant.firstName} ${consultant.lastName} (#${consultant.profile.employeeNumber})`
			: "";
	}

	return (
		<AutoCompleteInput<string, Consultant>
			value={value}
			getDisplayValue={getDisplayValue}
			suggestions={consultantList?.users || []}
			getValue={(c) => c.id}
			onSearch={setSearch}
			minChars={1}
			prefix={hidePrefix ? undefined : t("CONSULTANT")}
			onChange={onChange}
			initialValueSuggestion={consultant}
			{...rest}
		/>
	);
};

export default ConsultantAutoComplete;
